var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6948 6.76617C19.0982 6.36273 19.0982 5.70863 18.6948 5.3052C18.2914 4.90176 17.6373 4.90176 17.2338 5.3052L12.0011 10.5379L6.76574 5.30258C6.3623 4.89914 5.7082 4.89914 5.30476 5.30258C4.90133 5.70601 4.90133 6.36011 5.30477 6.76355L10.5401 11.9989L5.30258 17.2365C4.89914 17.6399 4.89914 18.294 5.30258 18.6974C5.70601 19.1009 6.36011 19.1009 6.76355 18.6974L12.0011 13.4599L17.236 18.6948C17.6395 19.0982 18.2936 19.0982 18.697 18.6948C19.1004 18.2914 19.1004 17.6373 18.697 17.2338L13.4621 11.9989L18.6948 6.76617Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.4cdefc873a467d2cafcbae852b248582.svg";
export { ForwardRef as ReactComponent };